"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("../../constants");
var _pricing = require("../../helpers/pricing");
var _newComponents = require("../../new-components");
var _reactRouterDom = require("react-router-dom");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _getPillType = function _getPillType(status) {
  if (status === 'paid') {
    return _newComponents.PILL_TYPES.SUCCESS_INVERT;
  }
  if (status === 'cancelled') {
    return _newComponents.PILL_TYPES.GHOST;
  }
  if (status === 'pending' || status === 'scheduled') {
    return _newComponents.PILL_TYPES.ORANGE;
  }
  return _newComponents.PILL_TYPES.ERROR;
};
var BookingListPayments = function BookingListPayments(_ref) {
  var payments = _ref.payments,
    userId = _ref.userId;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    cardType = _useState2[0],
    setCardType = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    scheduledPayments = _useState4[0],
    setScheduledPayments = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    formattedPayments = _useState6[0],
    setFormattedPayments = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    hasFeePayment = _useState8[0],
    setHasFeePayment = _useState8[1];
  var _useState9 = (0, _react.useState)("xxxx"),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    last4 = _useState10[0],
    setLast4 = _useState10[1];
  (0, _react.useEffect)(function () {
    setFormattedPayments((0, _pricing.handleCardFeePayments)(payments));
  }, []);
  (0, _react.useEffect)(function () {
    setHasFeePayment(formattedPayments.some(function (p) {
      return !!p.feePayment;
    }));
    setScheduledPayments(formattedPayments.filter(function (p) {
      return p.status === _constants.PAYMENT.STATUS_SCHEDULED;
    }));
  }, [formattedPayments]);
  (0, _react.useEffect)(function () {
    if (scheduledPayments.length > 0 && scheduledPayments[0].method) {
      setLast4(scheduledPayments[0].creditCard.lastFour);
      if (scheduledPayments[0].method !== undefined) {
        if (scheduledPayments[0].method.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.VISA.toLowerCase()) {
          setCardType('visa');
        } else if (scheduledPayments[0].method.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.MASTERCARD.toLowerCase()) {
          setCardType('mastercard');
        } else if (scheduledPayments[0].method.toLowerCase() === _constants.CREDIT_CARD_SCHEMES.AMEX.toLowerCase()) {
          setCardType('amex');
        }
      }
    }
  }, [scheduledPayments]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, scheduledPayments.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-component-padding d8-u-radius-md border width-100% margin-top-xxs margin-bottom-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-0 margin-bottom-0 flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center"
  }, /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
    name: cardType && cardType,
    className: "margin-right-sm"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-right-sm"
  }, "**** ", last4)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(location.pathname, "/update-payment-method"),
    className: "btn btn--bare btn--small d8-u-color-primary d8-u-text-semi-bold padding-sm"
  }, "Change")))), /*#__PURE__*/_react["default"].createElement(_newComponents.Table, null, /*#__PURE__*/_react["default"].createElement(_newComponents.TableHead, null, /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Name"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Date"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Status"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Card"), hasFeePayment && /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Fee"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Paid"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-left"
  }, "Registered")), /*#__PURE__*/_react["default"].createElement("tbody", null, formattedPayments.filter(function (p) {
    return p.ourReference !== _constants.CREDIT_CARD_FEE_REFERENCE;
  }).map(function (payment, key) {
    var _payment$creditCard, _payment$feePayment;
    var cardLastFour = payment === null || payment === void 0 || (_payment$creditCard = payment.creditCard) === null || _payment$creditCard === void 0 ? void 0 : _payment$creditCard.lastFour;
    var isUserPayment = payment.profile.id === userId;
    var paymentDate = (0, _moment["default"])(payment.datePaid || payment.dateScheduled).format('D MMM');
    var feeRegistered = 0;
    if (payment.feePayment) {
      feeRegistered = payment.feePayment.amountRegistered;
    }
    var finalRegistered = payment.amountRegistered + feeRegistered;
    var lastFour = function lastFour() {
      return cardLastFour && /*#__PURE__*/_react["default"].createElement("span", null, "X-", cardLastFour);
    };
    if (!isUserPayment && cardLastFour) {
      lastFour = function lastFour() {
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "d8-u-color-contrast-medium"
        }, "X-\u25CF\u25CF\u25CF\u25CF");
      };
    }
    return /*#__PURE__*/_react["default"].createElement(_newComponents.TableRow, {
      key: key
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, payment.profile.firstName), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, paymentDate), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, /*#__PURE__*/_react["default"].createElement(_newComponents.Pill, {
      title: payment.status || 'N/A',
      type: _getPillType(payment.status)
    })), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, lastFour(), ' '), hasFeePayment && /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, (0, _pricing.formatCurrency)(((payment === null || payment === void 0 || (_payment$feePayment = payment.feePayment) === null || _payment$feePayment === void 0 ? void 0 : _payment$feePayment.amountRegistered) || 0) * -1 / 100, payment.currencyRegistered, payment.currencyPaid)), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "d8-u-text-bold"
    }, (0, _pricing.formatCurrency)((payment.amountPaid || 0) / 100, payment.currencyPaid, payment.currencyPaid))), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-left"
    }, (0, _pricing.formatCurrency)((finalRegistered || 0) / 100, payment.currencyRegistered, payment.currencyRegistered)));
  }))));
};
BookingListPayments.propTypes = {
  payments: _propTypes["default"].array.isRequired,
  userId: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = BookingListPayments;